import type { Rotina } from "~/types/pagesMenu";

export const nomesRotinasInventario = {
	ASSOCIAR_LOTE: "Associação Automática de Lotes de Inventário",
	INVENTARIO_COLETOR: "Inventário no coletor",
	INVENTARIO_EXPRESSO: "B342 — Inventário expresso de picking",
	CARA_CRACHA: "Conferência cara-crachá",
} as const;

export type RotinasInventario = typeof nomesRotinasInventario[keyof typeof nomesRotinasInventario];

/**
 * Rotinas da categoria Inventário.
 *
 * ATENÇÃO ao campo `nome`: ele é comparado contra `ACEUSU_ID_MENU_PF` da
 * `CORE_ACESSO_USUARIO`, e o item some do menu em silêncio quando não casa.
 *
 * A B341 (`inventario/coletor`) divide o identificador com a B348 porque, no
 * Delphi, ela não tem item de menu próprio: é aberta pela tela de associação de
 * lote. Ambos os ids foram conferidos contra a base HARPIAEPOCA —
 * `AssociaraoUsurioLotesdeInventrio1` com 591 usuários e
 * `mni_coletor_inventario_expresso_picking` com 86. Numa base de cliente com id
 * próprio, é este campo que muda.
 */
const rotinasInventario: Rotina[] = [
	{
		categoria: "Inventário",
		label: nomesRotinasInventario.ASSOCIAR_LOTE,
		nome: "AssociaraoUsurioLotesdeInventrio1",
		rotina: "inventario/associarLote",
		tela: "PROC_INVENTARIO_COLETOR_ASSOCIAR_LOTE",
		disponivel: true,
	},
	{
		categoria: "Inventário",
		label: nomesRotinasInventario.INVENTARIO_COLETOR,
		nome: "AssociaraoUsurioLotesdeInventrio1",
		rotina: "inventario/coletor",
		tela: "PROC_INVENTARIO_COLETOR",
		disponivel: true,
	},
	{
		categoria: "Inventário",
		label: nomesRotinasInventario.INVENTARIO_EXPRESSO,
		nome: "mni_coletor_inventario_expresso_picking",
		rotina: "inventario/expresso",
		tela: "PROC_INVENTARIO_EXPRESSO_COLETOR",
		disponivel: true,
	},
	{
		/*
		 * `mni_RegistroConferenciaPosicoesPaletes` foi conferido nas fontes:
		 * `SIST_MAINFORM.pas:3447` abre exatamente
		 * `TfPROC_CARA_CRACHA_CONF_COLETOR` por este item. Existe na base
		 * HARPIAEPOCA com 592 usuários.
		 */
		categoria: "Inventário",
		label: nomesRotinasInventario.CARA_CRACHA,
		nome: "mni_RegistroConferenciaPosicoesPaletes",
		rotina: "conferencia/caraCracha",
		tela: "PROC_CARA_CRACHA_CONF_COLETOR",
		disponivel: true,
	},
];

export default rotinasInventario;
